function initWaveAnimation() {
  const cfg = Object.assign({
    color: '#ae9479',
    speed: 55,
    trace: 130,
    lineWidth: 3
  }, window.WAVE_CONFIG || {});
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setupCanvas(canvas) {
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { ctx, w: rect.width, h: rect.height };
  }
  const canvases = document.querySelectorAll('canvas.wave-animation');
  if (!canvases.length) return;
  const waves = [...canvases].map(canvas => {
    const d = setupCanvas(canvas);
    const wv = {
      canvas, ...d,
      freq: parseFloat(canvas.dataset.freq) || 6,
      amp: parseFloat(canvas.dataset.amp) || 0.5,
      speed: parseFloat(canvas.dataset.speed) || cfg.speed,
      visible: false,
      start: null
    };
    wv.wavelength = wv.w / (wv.freq * 0.5 + 1);
    return wv;
  });
  window.addEventListener('resize', () => {
    waves.forEach(wv => {
      const d = setupCanvas(wv.canvas);
      wv.ctx = d.ctx; wv.w = d.w; wv.h = d.h;
      wv.wavelength = wv.w / (wv.freq * 0.5 + 1);
      if (reduceMotion && wv.visible) drawStatic(wv);
    });
  });
  function yAt(x, wv, phase) {
    const pad = 10;
    const mid = wv.h / 2;
    const A = (wv.h / 2 - pad) * wv.amp;
    return mid - Math.sin((x / wv.wavelength) * Math.PI * 2 - phase) * A;
  }
  function drawStatic(wv) {
    const { ctx, w } = wv;
    ctx.clearRect(0, 0, w, wv.h);
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    const bleed = cfg.lineWidth;
    ctx.beginPath();
    ctx.moveTo(-bleed, yAt(-bleed, wv, 0));
    for (let x = -bleed + 1; x <= w + bleed; x++) {
      ctx.lineTo(x, yAt(x, wv, 0));
    }
    ctx.lineWidth = cfg.lineWidth;
    ctx.strokeStyle = cfg.color;
    ctx.stroke();
  }
  function drawFrame(wv, ts) {
    if (wv.start === null) wv.start = ts;
    const t = (ts - wv.start) / 1000;
    const { ctx, w } = wv;
    ctx.clearRect(0, 0, w, wv.h);
    const drawTime = w / cfg.trace;
    const drawing = t < drawTime;
    const penX = drawing ? t * cfg.trace : w;
    const phase = (t * wv.speed) / wv.wavelength * Math.PI * 2;
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    const bleed = cfg.lineWidth;
    if (drawing) {
      ctx.beginPath();
      for (let x = -bleed; x <= w + bleed; x++) {
        const y = yAt(x, wv, phase);
        x === -bleed ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
      ctx.lineWidth = 1.5;
      ctx.strokeStyle = cfg.color + '33';
      ctx.stroke();
    }
    const penEnd = drawing ? penX : w + bleed;
    ctx.beginPath();
    ctx.moveTo(-bleed, yAt(-bleed, wv, phase));
    for (let x = -bleed + 1; x <= penEnd; x++) {
      ctx.lineTo(x, yAt(x, wv, phase));
    }
    ctx.lineWidth = cfg.lineWidth;
    ctx.strokeStyle = cfg.color;
    ctx.stroke();
    if (drawing) {
      const penY = yAt(penX, wv, phase);
      ctx.beginPath();
      ctx.arc(penX, penY, cfg.lineWidth * 0.85, 0, Math.PI * 2);
      ctx.fillStyle = cfg.color;
      ctx.fill();
    }
  }
  let running = false;
  function draw(ts) {
    let anyVisible = false;
    waves.forEach(wv => {
      if (wv.visible) {
        anyVisible = true;
        drawFrame(wv, ts);
      }
    });
    if (anyVisible) requestAnimationFrame(draw);
    else running = false;
  }
  function startLoop() {
    if (running) return;
    running = true;
    requestAnimationFrame(draw);
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const wv = waves.find(w => w.canvas === entry.target);
        if (!wv) return;
        if (entry.isIntersecting) {
          if (!wv.visible) {
            wv.visible = true;
            if (reduceMotion) {
              drawStatic(wv);
            } else {
              wv.start = null;
              startLoop();
            }
          }
        } else {
          wv.visible = false;
        }
      });
    }, { threshold: 0.2 });
    waves.forEach(wv => observer.observe(wv.canvas));
  } else {
    waves.forEach(wv => {
      wv.visible = true;
      if (reduceMotion) drawStatic(wv);
    });
    if (!reduceMotion) startLoop();
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWaveAnimation);
} else {
  initWaveAnimation();
}